import React from 'react';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { AssetList } from './AssetList';
import { useTranslation } from '../../contexts/translation';
import { useStyles } from './AssetForm.styles';

export function AssetPage() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <PageHeader title={t('page.asset.main-headline')} xs={6} className={classes.headline} />
      <PageContent>
        <AssetList />
      </PageContent>
    </>
  );
}
